import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../../components/input/fields/text-field';
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { AddItem, GetById, UpdateItem } from '../../../utils/functions';
import { Typography, Box } from "@mui/material";
import { DataContext } from '../../../App';
import { NavLink } from 'react-router-dom';
import LoadingApp from "../../../components/loadingApp/loadingApp";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


const Manage = ({ itemId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const context = useContext(DataContext);
  const Id = itemId ?? null;
  const [category, setCategories] = useState(null);
  const [isBtnDisable, setIsBtnDisable] = useState(false);

  const [isMobileTablet, setIsMobileTablet] = useState(window.matchMedia("(max-width: 991px)").matches);
  const [formValues, setFormValues] = useState({
    id: Id,
    label: null,
    value: null
  });

  const checkValues = () => {
    if (!formValues.label) {
      toast.error(t("ToastErrorNameRequired"));
      return false;
    }
    if (!formValues.value) {
      toast.error(t("ToastErrorValueRequired"));
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsBtnDisable(true);
    
    if (checkValues()) {
      try {
        if (Id) {
          await UpdateItem('Categories', formValues);
        } else {
          await AddItem('Categories', formValues);
        }
        await context.updateData("categories");
        navigate("/admin/categories")

      } catch (error) {
        console.error('ErrorCategories', error);
      }
    }
    
    setIsBtnDisable(false);
  }

  useEffect(() => {
    const fetchCategories = async () => {
      if (!category && Id) {
        const data = await GetById("Categories", Id);
        if (data) {
          setCategories(data);
        }
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    if (category) {
      setFormValues({
        id: Id,
        label: category?.label ?? null,
        value: category?.value ?? null,
      });
    }
  }, [category]);

  if (!category && Id) {
    return <LoadingApp />;
  }

  return (
    <div className="container-admin mt-5">
      <div className="row">
        <NavLink className="come-back-admin" to={"/admin/categories"}>
          <FontAwesomeIcon icon={faAngleLeft} />
          {t("Back")}
        </NavLink>
        <div className="row mt-5">

          {/* GENERAL INFORMATIONS */}
          <div className="row mt-2 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("GeneralInformations")}
              </h5>
              <p>{t("CategoriesGeneralInformations")}</p>

            </div>
            <div className="col-lg-6 col-12">
              <TextField
                id="label"
                name="label"
                label={t("Name")}
                type="text"
                placeholder={t("Insert")}
                value={formValues.label}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    label: e.target.value
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div> 
            <div className="col-lg-6 col-12">
              <TextField
                id="value"
                name="value"
                label={t("Value")}
                type="text"
                placeholder={t("Insert")}
                value={formValues.value}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    value: e.target.value
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
          </div>
          <hr />

          {/* DESCRIPTION */}
          {/* <div className="row mt-3 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("Description")}
              </h5>
              <p>{t("CategoriesDescriptionInformations")}</p>

            </div>
            <div className="col-lg-4 col-12">
              <TextField
                id="linkMenuTargetText"
                name="linkMenuTargetText"
                label={t("TextMenu")}
                type="text"
                placeholder={t("Insert")}
                value={formValues.linkMenu?.text}
                isRequired={true}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    linkMenu: {
                      ...prevValues.linkMenu,
                      text: e.target.value
                    }
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="col-lg-4 col-12">
              <TextField
                id="linkMenuUrl"
                name="linkMenuUrl"
                label={t("UrlMenu")}
                type="text"
                placeholder={t("Insert")}
                isRequired={true}
                value={formValues.linkMenu?.url}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    linkMenu: {
                      ...prevValues.linkMenu,
                      url: e.target.value
                    }
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
            <div className="col-12 mt-3">
              <label className="ms-1 fs-6 text-black mb-3">
                {t("Description")}<span className="text-danger">*</span>
              </label>
              <Editor
                value={formValues?.description}
                onTextChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    description: e.htmlValue
                  }));
                }}
                placeholder={t("Insert")}
                className={`w-100 mb-2 ${!isMobileTablet ? "h-150" : ""}`}
              />
            </div>

            <div className="col-lg-4 col-12 mt-5 mt-lg-2">
              <TextField
                id="ctaText"
                name="ctaText"
                label={t("CtaText")}
                type="text"
                placeholder={t("Insert")}
                isRequired={true}
                value={formValues.cta.text}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    cta: { ...prevValues.cta, text: e.target.value },
                  }))
                }
                inputClassName={"grey-input w-100"}
              />
            </div>
          </div>
          <hr /> */}

          {/* SEO */}
          {/* <div className="row mt-3 mb-5">
            <div className="mb-5">
              <h5 className="text-black fs-6 mb-6 fw-semibold mb-3 text-uppercase">
                {t("Seo")}
              </h5>
              <p>{t("CategoriesSeoInformations")}</p>
            </div>
            <div className="flex-wrap col-lg-6 col-12 my-3">
              <div className="d-flex flex-column position-relative">
                <label
                  className={`ms-1 fs-6 text-black w-full mb-2`}
                >
                  {t("Title")}<span className="text-danger">*</span>
                </label>
                <textarea
                  maxLength={60}
                  value={formValues.seoInformation?.title}
                  className="grey-input w-100 min-h-100px"
                  placeholder={t("Insert")}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      seoInformation: {
                        ...prevValues.seoInformation,
                        title: e.target.value,
                      },
                    }))
                  }
                ></textarea>
                <p className="paragraph position-absolute end-0 top-100 font-description-small">
                  {t("Max60")}
                </p>
              </div>
            </div>
            <div className="flex-wrap col-lg-6 col-12 my-3">
              <div className="d-flex flex-column position-relative">
                <label
                  className={`ms-1 text-lg fw-normal fs-6 text-black w-full mb-2`}
                >
                  {t("MetaDescription")}
                </label>
                <textarea
                  maxLength={160}
                  value={formValues.seoInformation?.metaDescription}
                  className="grey-input w-100 min-h-100px"
                  placeholder={t("Insert")}
                  onChange={(e) =>
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      seoInformation: {
                        ...prevValues.seoInformation,
                        metaDescription: e.target.value,
                      },
                    }))
                  }
                ></textarea>
                <p className="paragraph position-absolute end-0 top-100 font-description-small ">
                  {t("Max160")}
                </p>
              </div>
            </div>
            <div className="flex-wrap col-lg-6 col-12 my-3">
              <label className={`ms-1 fs-6 text-black w-full mb-2`}>
                {t("LinkUrl")}<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                value={formValues.seoInformation?.linkUrl}
                className="grey-input w-100"
                placeholder={t("Insert")}
                onChange={(e) =>
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    seoInformation: {
                      ...prevValues.seoInformation,
                      linkUrl: e.target.value,
                    },
                  }))
                }
              />
            </div>
            <div className="flex-wrap col-lg-6 col-12 mt-3">
              <TagsInput
                label={t("Keywords")}
                key={formValues.seoInformation?.keywords?.join(",")}
                placeholder={t("KeywordsPlaceholder")}
                selectedTags={selectedTags}
                defaultTags={formValues.seoInformation?.keywords ?? []}
              />
            </div>
          </div>
          <hr />
          */}

        </div>
      </div>
      <div className="col-12 mt-3 d-flex justify-content-end p-5 p-lg-0">
        <button onClick={handleSubmit} className="admin-button border-none text-uppercase" disabled={isBtnDisable}>
          {Id ? t("Update") : t("Create")}
        </button>
      </div>
    </div>
  );
};

export default Manage;